import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import EditorialMarquee from "@/components/EditorialMarquee";
import { FadeUp, SectionLabel } from "@/components/Reveal";
import { useContent } from "@/lib/api";

const INCLUDES = [
  "Valutazione iniziale",
  "Definizione degli obiettivi",
  "Programmazione personalizzata",
  "Scheda di allenamento",
  "Monitoraggio dei progressi",
  "Modifiche alla programmazione quando necessario",
  "Supporto e comunicazione online",
  "Analisi e correzione della tecnica tramite video",
];

const STEPS = [
  ["Conosciamoci", "Un primo contatto per capire chi sei, cosa cerchi e se il percorso è adatto a te."],
  ["Analizziamo il tuo punto di partenza", "Valutazione iniziale completa: storia, abitudini, disponibilità e condizione attuale."],
  ["Costruiamo il programma", "Una programmazione personalizzata e una scheda costruita sui tuoi obiettivi e sulla tua vita."],
  ["Monitoriamo i progressi", "Check-in e monitoraggio costante per capire cosa funziona e cosa migliorare."],
  ["Adattiamo il percorso", "Il programma evolve con te: modifiche e aggiornamenti quando servono davvero."],
];

export default function Coaching() {
  const content = useContent();

  return (
    <div data-testid="coaching-page">
      <Nav />
      <section className="mx-auto max-w-7xl px-6 pb-24 pt-40 lg:px-12 lg:pt-52">
        <SectionLabel>Coaching online</SectionLabel>
        <FadeUp as="h1" delay={0.1} className="mt-6 max-w-4xl font-display text-5xl leading-[1.05] text-ivory md:text-7xl" data-testid="coaching-title">
          Il tuo percorso,
          <br />
          <span className="italic text-mist">costruito su di te.</span>
        </FadeUp>
        <FadeUp delay={0.2} className="mt-10 max-w-2xl text-sm leading-loose text-mute md:text-base" data-testid="coaching-intro">
          {content.coaching_intro}
        </FadeUp>
      </section>

      <section className="border-t border-line bg-surface" data-testid="coaching-includes">
        <div className="mx-auto max-w-7xl px-6 py-24 lg:px-12 lg:py-32">
          <SectionLabel>Cosa comprende</SectionLabel>
          <div className="mt-12 grid gap-px border border-line bg-line sm:grid-cols-2 lg:grid-cols-4">
            {INCLUDES.map((item, i) => (
              <FadeUp key={item} delay={i * 0.05} className="bg-surface p-8 transition-colors duration-500 hover:bg-ink" data-testid={`include-${i + 1}`}>
                <span className="font-display text-2xl italic text-sage">{String(i + 1).padStart(2, "0")}</span>
                <p className="mt-4 text-sm leading-relaxed text-ivory/90">{item}</p>
              </FadeUp>
            ))}
          </div>
        </div>
      </section>

      <EditorialMarquee />

      <section className="mx-auto max-w-7xl px-6 py-24 lg:px-12 lg:py-32" data-testid="coaching-steps">
        <SectionLabel>Come funziona</SectionLabel>
        <div className="mt-12 flex flex-col">
          {STEPS.map(([title, desc], i) => (
            <FadeUp key={title} delay={i * 0.06} className="group grid gap-4 border-b border-line py-10 first:border-t md:grid-cols-[120px_1fr_1.2fr] md:items-baseline" data-testid={`step-${i + 1}`}>
              <span className="font-display text-5xl text-sage transition-colors duration-500 group-hover:text-mist md:text-6xl">
                {String(i + 1).padStart(2, "0")}
              </span>
              <h3 className="font-display text-2xl text-ivory md:text-3xl">{title}</h3>
              <p className="max-w-md text-sm leading-relaxed text-mute">{desc}</p>
            </FadeUp>
          ))}
        </div>
        <FadeUp delay={0.2} className="mt-16 flex flex-wrap gap-4">
          <Link to="/pacchetti" data-testid="coaching-cta-packages" className="btn-primary">
            Scegli il tuo percorso <ArrowRight size={14} />
          </Link>
          <Link to="/contatti" data-testid="coaching-cta-contact" className="btn-outline">
            Richiedi informazioni
          </Link>
        </FadeUp>
      </section>
      <Footer content={content} />
    </div>
  );
}
